/* eslint-disable @typescript-eslint/no-explicit-any */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AdminUpdateUserInput = {
  bciDealer?: InputMaybe<Scalars['String']>;
  bciPassword?: InputMaybe<Scalars['String']>;
  bciUsername?: InputMaybe<Scalars['String']>;
  dealer?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
  zurichPassword?: InputMaybe<Scalars['String']>;
};

export enum AllowedComponent {
  Button = 'BUTTON',
  Card = 'CARD',
  Widget = 'WIDGET'
}

export enum AvailableProcedures {
  AdministrativeExpenses = 'ADMINISTRATIVE_EXPENSES',
  CirculationPermit = 'CIRCULATION_PERMIT',
  CivilRegistration = 'CIVIL_REGISTRATION',
  CivilRegistrationPlate = 'CIVIL_REGISTRATION_PLATE',
  GreenTax = 'GREEN_TAX',
  Notary = 'NOTARY',
  ObligatoryInsurance = 'OBLIGATORY_INSURANCE',
  ProhibitionOfAlienating = 'PROHIBITION_OF_ALIENATING',
  Tag = 'TAG',
  VehicleInspection = 'VEHICLE_INSPECTION'
}

export type Car = {
  __typename?: 'Car';
  brand?: Maybe<Scalars['String']>;
  carId: Scalars['String'];
  cit?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  vehicleType?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export enum CarCondition {
  New = 'NEW',
  Seminew = 'SEMINEW',
  Used = 'USED'
}

export type CardInformation = {
  __typename?: 'CardInformation';
  cardBankNumber: Scalars['String'];
  cardExpirationDate: Scalars['String'];
  cardNumber: Scalars['String'];
  cardType: Scalars['String'];
};

export type CardInformationInput = {
  cardBankNumber: Scalars['String'];
  cardExpirationDate: Scalars['String'];
  cardNumber: Scalars['String'];
  cardType: Scalars['String'];
};

export type Concessionaire = {
  __typename?: 'Concessionaire';
  address: Scalars['String'];
  apiKey: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  commerceCode: Scalars['String'];
  commune?: Maybe<Scalars['String']>;
  concessionaireId: Scalars['String'];
  concessionaireType: ConcessionaireType;
  contactMail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone: Scalars['String'];
  createdAt: Scalars['String'];
  integration?: Maybe<Integration>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  rut: Scalars['String'];
  siteUrl: Scalars['String'];
  termsConditionsFile?: Maybe<ConcessionaireTermsConditionsFile>;
};

export type ConcessionaireStyle = {
  __typename?: 'ConcessionaireStyle';
  buttonTextColor?: Maybe<Scalars['String']>;
  componentType: AllowedComponent;
  concessionaireId: Scalars['String'];
  concessionaireIsoLogoUrl?: Maybe<Scalars['String']>;
  concessionaireLogoUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  offerTextColor?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  showRemainingQuantity: Scalars['Boolean'];
  textColor?: Maybe<Scalars['String']>;
};

export type ConcessionaireTermsConditionsFile = {
  __typename?: 'ConcessionaireTermsConditionsFile';
  encoding?: Maybe<Scalars['String']>;
  fileId: Scalars['String'];
  filename?: Maybe<Scalars['String']>;
  mimetype?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum ConcessionaireType {
  Car = 'CAR',
  Usedcar = 'USEDCAR'
}

export enum CoverageType {
  AltaGama = 'ALTA_GAMA',
  Estandar = 'ESTANDAR',
  Full = 'FULL',
  Light = 'LIGHT',
  Premium = 'PREMIUM'
}

export type CreateCarInput = {
  brand?: InputMaybe<Scalars['String']>;
  cit?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  vehicleType?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type CreateInsuranceInput = {
  birthday?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  carCondition?: InputMaybe<CarCondition>;
  carPlate?: InputMaybe<Scalars['String']>;
  comercialUseType?: InputMaybe<Scalars['String']>;
  commune?: InputMaybe<Scalars['String']>;
  communeCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstSurname?: InputMaybe<Scalars['String']>;
  insuranceInterest: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  paymentType: PaymentType;
  phone?: InputMaybe<Scalars['String']>;
  rut?: InputMaybe<Scalars['String']>;
  useType: InsuranceUseType;
  username?: InputMaybe<Scalars['String']>;
};

export type CreateLitePurchaseIntentInput = {
  brand?: InputMaybe<Scalars['String']>;
  cit?: InputMaybe<Scalars['String']>;
  customerRut: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  obligatoryInsurance?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  quotationId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['Boolean']>;
  vehicleType?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type CreateOperationalCostsInput = {
  selectedProcedures?: InputMaybe<Array<SelectedProceduresInput>>;
};

export type CreateProposalInput = {
  carChassis?: InputMaybe<Scalars['String']>;
  carColor?: InputMaybe<Scalars['String']>;
  carEngineNumber?: InputMaybe<Scalars['String']>;
  carPlate?: InputMaybe<Scalars['String']>;
  cardInformation?: InputMaybe<CardInformationInput>;
  dealer?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  issuerRut?: InputMaybe<Scalars['String']>;
  paymentDay?: InputMaybe<Scalars['String']>;
  policyIssued?: InputMaybe<Scalars['Boolean']>;
  proposalCustomer?: InputMaybe<ProposalCustomerInput>;
  proposalInsured?: InputMaybe<ProposalInsuredInput>;
  proposalInternalId?: InputMaybe<Scalars['String']>;
  proposalInternalWebPageUrl?: InputMaybe<Scalars['String']>;
  proposalProductId: Scalars['String'];
};

export type CreateUserInput = {
  concessionaireName?: InputMaybe<Scalars['String']>;
  dealer?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  extraConcessionaireName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rut?: InputMaybe<Scalars['String']>;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Scalars['String']>;
  addressNumber?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  commune?: Maybe<Scalars['String']>;
  communeCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstSurname?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rut: Scalars['String'];
};

export type CustomerInput = {
  commune?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstSurname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  rut: Scalars['String'];
};

export type GuestUser = {
  __typename?: 'GuestUser';
  ExpirationDate: Scalars['Int'];
  concessionaireName: Scalars['String'];
  email: Scalars['String'];
  signupToken: Scalars['String'];
};

export type Insurance = {
  __typename?: 'Insurance';
  insuranceId: Scalars['String'];
  insuranceInput: InsuranceInput;
  insuranceProposal?: Maybe<InsuranceProposal>;
  selectedInsuranceProducts?: Maybe<Array<InsuranceSimulationProduct>>;
};

export type InsuranceInput = {
  __typename?: 'InsuranceInput';
  address?: Maybe<Scalars['String']>;
  addressNumber?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  carCondition?: Maybe<CarCondition>;
  carPlate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comercialUseType?: Maybe<Scalars['String']>;
  commune?: Maybe<Scalars['String']>;
  communeCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstSurname?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  insuranceInterest: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  paymentType: PaymentType;
  phone?: Maybe<Scalars['String']>;
  rut?: Maybe<Scalars['String']>;
  useType: InsuranceUseType;
  username?: Maybe<Scalars['String']>;
};

export type InsuranceProposal = {
  __typename?: 'InsuranceProposal';
  carChassis?: Maybe<Scalars['String']>;
  carColor?: Maybe<Scalars['String']>;
  carEngineNumber?: Maybe<Scalars['String']>;
  carPlate?: Maybe<Scalars['String']>;
  cardInformation?: Maybe<CardInformation>;
  dealer?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  issuerRut?: Maybe<Scalars['String']>;
  paymentDay?: Maybe<Scalars['String']>;
  policyIssued?: Maybe<Scalars['Boolean']>;
  proposalInternalId?: Maybe<Scalars['String']>;
  proposalInternalWebPageUrl?: Maybe<Scalars['String']>;
  proposalProductId?: Maybe<Scalars['String']>;
};

export type InsuranceSimulationProduct = {
  __typename?: 'InsuranceSimulationProduct';
  PdfUrl?: Maybe<Scalars['String']>;
  comercialUseType?: Maybe<Scalars['String']>;
  coverageDetails: Scalars['String'];
  coverageType?: Maybe<CoverageType>;
  deductible: Scalars['Float'];
  installments?: Maybe<Scalars['String']>;
  insuranceProvider: Scalars['String'];
  internalProductId?: Maybe<Scalars['String']>;
  monthlyValue: Scalars['Float'];
  monthlyValueInUF: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  paymentType: PaymentType;
  pdfKey?: Maybe<Scalars['String']>;
  period: Scalars['String'];
  productId: Scalars['String'];
  responseId?: Maybe<Scalars['String']>;
  useType: InsuranceUseType;
};

export type InsuranceSimulationProductInput = {
  PdfUrl?: InputMaybe<Scalars['String']>;
  coverageDetails: Scalars['String'];
  coverageType?: InputMaybe<CoverageType>;
  deductible: Scalars['Float'];
  installments?: InputMaybe<Scalars['String']>;
  insuranceProvider: Scalars['String'];
  internalProductId?: InputMaybe<Scalars['String']>;
  monthlyValue: Scalars['Float'];
  monthlyValueInUF: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
  paymentType: PaymentType;
  pdfKey?: InputMaybe<Scalars['String']>;
  period: Scalars['String'];
  productId: Scalars['String'];
  responseId?: InputMaybe<Scalars['String']>;
  useType: InsuranceUseType;
};

export enum InsuranceUseType {
  Commercial = 'COMMERCIAL',
  Private = 'PRIVATE'
}

export type Integration = {
  __typename?: 'Integration';
  config?: Maybe<IntegrationConfig>;
  enabled: Scalars['Boolean'];
};

export type IntegrationConfig = {
  __typename?: 'IntegrationConfig';
  concessionaireAssignCarMethod: IntegrationMethods;
  concessionaireAssignCarUrl: Scalars['String'];
  concessionaireIntegrationBasePath: Scalars['String'];
  concessionaireModifyStatusMethod: IntegrationMethods;
  concessionaireModifyStatusUrl: Scalars['String'];
};

export enum IntegrationMethods {
  Get = 'GET',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type InviteUserInput = {
  concessionaireName: Scalars['String'];
  dealer: Scalars['String'];
  email: Scalars['String'];
  extraConcessionaireName?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  name: Scalars['String'];
  rut: Scalars['String'];
};

export type LitePurchaseIntent = {
  __typename?: 'LitePurchaseIntent';
  car?: Maybe<Car>;
  createdAt: Scalars['String'];
  customer?: Maybe<Customer>;
  customerRut?: Maybe<Scalars['String']>;
  insurance?: Maybe<Insurance>;
  obligatoryInsurance?: Maybe<Scalars['Boolean']>;
  operationalCosts?: Maybe<OperationalCosts>;
  purchaseIntent?: Maybe<PurchaseIntent>;
  purchaseIntentId: Scalars['String'];
  quotationId?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['Boolean']>;
  userInformation?: Maybe<UserInformation>;
};

export type LitePurchaseIntentConnection = {
  __typename?: 'LitePurchaseIntentConnection';
  edges: Array<LitePurchaseIntentEdge>;
  pageInfo: LitePurchaseIntentPageInfo;
};

export type LitePurchaseIntentCursor = {
  __typename?: 'LitePurchaseIntentCursor';
  createdAt: Scalars['String'];
  purchaseIntentId: Scalars['String'];
};

export type LitePurchaseIntentCursorInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  insuranceProducts?: InputMaybe<Scalars['Boolean']>;
  purchaseIntentId?: InputMaybe<Scalars['String']>;
  rut?: InputMaybe<Scalars['String']>;
  simulationId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type LitePurchaseIntentEdge = {
  __typename?: 'LitePurchaseIntentEdge';
  cursor: LitePurchaseIntentCursor;
  node: LitePurchaseIntent;
};

export type LitePurchaseIntentPageInfo = {
  __typename?: 'LitePurchaseIntentPageInfo';
  endCursor?: Maybe<LitePurchaseIntentCursor>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<LitePurchaseIntentCursor>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminUpdateUser: Scalars['String'];
  callAnalytics: Scalars['String'];
  createCar: Car;
  createCustomer: Customer;
  createInsurance: Insurance;
  createLitePurchaseIntent: LitePurchaseIntent;
  createOperationalCosts: OperationalCosts;
  createProposal: Scalars['String'];
  createUser: Scalars['String'];
  deleteSignUpInvitation: Scalars['String'];
  inviteUser: Scalars['String'];
  updateInsurance: Insurance;
};


export type MutationAdminUpdateUserArgs = {
  updateUserInput: AdminUpdateUserInput;
};


export type MutationCallAnalyticsArgs = {
  event?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCarArgs = {
  createCarInput?: InputMaybe<CreateCarInput>;
};


export type MutationCreateCustomerArgs = {
  customerInput?: InputMaybe<CustomerInput>;
};


export type MutationCreateInsuranceArgs = {
  createInsuranceInput: CreateInsuranceInput;
};


export type MutationCreateLitePurchaseIntentArgs = {
  createLitePurchaseIntentInput: CreateLitePurchaseIntentInput;
};


export type MutationCreateOperationalCostsArgs = {
  createOperationalCostsInput?: InputMaybe<CreateOperationalCostsInput>;
};


export type MutationCreateProposalArgs = {
  createProposalInput: CreateProposalInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationDeleteSignUpInvitationArgs = {
  deleteSignUpInput: Scalars['String'];
};


export type MutationInviteUserArgs = {
  inviteUserInput?: InputMaybe<InviteUserInput>;
};


export type MutationUpdateInsuranceArgs = {
  updateInsuranceInput: UpdateInsuranceInput;
};

export type OperationalCosts = {
  __typename?: 'OperationalCosts';
  createdAt?: Maybe<Scalars['String']>;
  operationalCostsId: Scalars['String'];
  procedures: Array<Procedure>;
  totalOperationalCost: Scalars['Int'];
};

export enum PaymentType {
  Cash = 'CASH',
  Installments = 'INSTALLMENTS',
  Pac = 'PAC'
}

export type Procedure = {
  __typename?: 'Procedure';
  name: AvailableProcedures;
  price: Scalars['Int'];
  selected: Scalars['Boolean'];
};

export type ProposalCustomerInput = {
  address?: InputMaybe<Scalars['String']>;
  addressNumber?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  commune?: InputMaybe<Scalars['String']>;
  communeCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstSurname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  rut?: InputMaybe<Scalars['String']>;
};

export type ProposalInsuredInput = {
  address?: InputMaybe<Scalars['String']>;
  addressNumber?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  commune?: InputMaybe<Scalars['String']>;
  communeCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
};

export type PurchaseIntent = {
  __typename?: 'PurchaseIntent';
  concessionaireId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  car?: Maybe<Car>;
  concessionaire?: Maybe<Concessionaire>;
  concessionaireStyle?: Maybe<ConcessionaireStyle>;
  customer?: Maybe<Customer>;
  getBciSimulation?: Maybe<Array<InsuranceSimulationProduct>>;
  getHdiSimulation?: Maybe<Array<InsuranceSimulationProduct>>;
  getInsurance?: Maybe<Insurance>;
  getInsuranceCsv: Scalars['String'];
  getModels: Array<Scalars['String']>;
  getPolicy?: Maybe<Scalars['String']>;
  getUser: User;
  getZurichSimulation?: Maybe<Array<InsuranceSimulationProduct>>;
  insuranceVoucher: Scalars['String'];
  listGuestUser: Array<GuestUser>;
  listInsuranceProposalToCsv: Scalars['String'];
  listLitePurchaseIntent: Array<LitePurchaseIntent>;
  listLitePurchaseIntentToCsv: Scalars['String'];
  listPurchaseToCsv: Scalars['String'];
  listUser: Array<User>;
  operationalCosts?: Maybe<OperationalCosts>;
  operationalCostsVoucher: Scalars['String'];
  paginateLitePurchaseIntent?: Maybe<LitePurchaseIntentConnection>;
  persistedOperationalCosts?: Maybe<OperationalCosts>;
  searchLitePurchaseIntent: Array<LitePurchaseIntent>;
  unitedLitePurchaseIntent: LitePurchaseIntent;
};


export type QueryConcessionaireArgs = {
  concessionaireId?: InputMaybe<Scalars['String']>;
};


export type QueryGetModelsArgs = {
  brand: Scalars['String'];
};


export type QueryGetUserArgs = {
  cognitoId?: InputMaybe<Scalars['String']>;
};


export type QueryListGuestUserArgs = {
  concessionaireName: Scalars['String'];
};


export type QueryListInsuranceProposalToCsvArgs = {
  dateRange: Array<Scalars['String']>;
};


export type QueryListLitePurchaseIntentToCsvArgs = {
  dateRange: Array<Scalars['String']>;
};


export type QueryListPurchaseToCsvArgs = {
  dateRange: Array<Scalars['String']>;
};


export type QueryOperationalCostsVoucherArgs = {
  operationalCostsVoucherInput: Array<SelectedProceduresInput>;
};


export type QueryPaginateLitePurchaseIntentArgs = {
  after: LitePurchaseIntentCursorInput;
  first: Scalars['Int'];
};


export type QuerySearchLitePurchaseIntentArgs = {
  searchInput: SearchInput;
};

export type SearchInput = {
  insuranceSearch?: InputMaybe<Scalars['Boolean']>;
  searchString: Scalars['String'];
};

export type SelectedProceduresInput = {
  name: AvailableProcedures;
  price: Scalars['Int'];
  selected: Scalars['Boolean'];
};

export type UpdateInsuranceInput = {
  insuranceProducts?: InputMaybe<Array<InsuranceSimulationProductInput>>;
};

export type User = {
  __typename?: 'User';
  bciDealer?: Maybe<Scalars['String']>;
  bciPassword?: Maybe<Scalars['String']>;
  bciUsername?: Maybe<Scalars['String']>;
  cognitoId: Scalars['String'];
  concessionaireId: Scalars['String'];
  dealer: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  name: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  zurichPassword?: Maybe<Scalars['String']>;
};

export type UserInformation = {
  __typename?: 'UserInformation';
  dealer?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};
